export default {
  toggleLoadingMargin(state, loading = false) {
    state.loadingMargin = loading;
  },
  toggleLoadingMarginSave(state, loading = false) {
    state.loadingMarginSave = loading;
  },
  setMargin(state, margin) {
    Object.assign(state.margin, margin);
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/configuration-invoice/store/mutations.js